import { useContext } from 'react';
import {
	JOIN_COMMON_MARKETS_ROOM,
	LEAVE_COMMON_MARKETS_ROOM,
	ON_MARKETS_CHANGE,
	SLATE_SCOPE_UPDATED,
} from '@sportspredict/shared';
import { SocketContext } from '@/contexts/socket.context';
import { useAppDispatch } from '@/store';
import api from '@/store/api';
import { useSocketRoom } from './use-socket-room.hook';

interface UseSlateScopeRealtimeInvalidationOptions {
	eventId?: string;
	lobbyId?: string;
	matchId?: string;
}

interface SlateScopeUpdatedPayload {
	tag?: string;
	eventId?: string;
	match_ids?: string[];
}

export function useSlateScopeRealtimeInvalidation({
	eventId,
	lobbyId,
	matchId,
}: UseSlateScopeRealtimeInvalidationOptions) {
	const socket = useContext(SocketContext);
	const dispatch = useAppDispatch();

	useSocketRoom({
		socket,
		enabled: Boolean(socket && eventId && lobbyId),
		eventName: ON_MARKETS_CHANGE,
		handler: (payload: SlateScopeUpdatedPayload) => {
			if (payload?.tag !== SLATE_SCOPE_UPDATED || payload?.eventId !== eventId || !lobbyId) {
				return;
			}

			const affectedMatchIds = new Set<string>(
				(Array.isArray(payload.match_ids) ? payload.match_ids : []).map(String)
			);
			if (matchId) affectedMatchIds.add(matchId);

			dispatch(
				api.util.invalidateTags([
					{ type: 'Game' },
					{ type: 'Game', id: `${eventId}-slates-${lobbyId}` },
					...Array.from(affectedMatchIds, (id) => ({ type: 'Market' as const, id })),
				])
			);
		},
		join: () => {
			if (socket) socket.emit(JOIN_COMMON_MARKETS_ROOM);
		},
		leave: () => {
			if (socket) socket.emit(LEAVE_COMMON_MARKETS_ROOM);
		},
	});
}
